import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import disableScroll from 'disable-scroll';
import CustomEvent from 'custom-event';
import { isMobile, getViewportHeight, isIEcheck, clickOutside } from '../../utils';
import './header-default.scss';

/**
 * Sticky header
 */
const stickyHeader = () => {
  const header = document.querySelector('.header');

  if (!header) return;

  const scrollHandler = () => {
    const topPosition = header.getBoundingClientRect().top;

    if (topPosition < 0) {
      if (!header.classList.contains('sticky')) {
        header.classList.add('sticky');
      }
    } else if (header.classList.contains('sticky')) {
      header.classList.remove('sticky');
    }
  };

  scrollHandler();
  window.addEventListener('scroll', scrollHandler);
};

/**
 * Toggle Navigation
 */

function ToggleNav() {
  const header = document.querySelector('.header');
  const button = header.querySelector('.header__nav-toggle');
  const nav = header.querySelector('.header__nav');
  const navScrollSpace = header.querySelector('.header__nav-inner');

  if (!header || !button || !nav) return;

  this.state = {
    isOpen: false,
  };
  this.sel = nav;
  const showEvent = new CustomEvent('show');

  const setNavScrollSpaceHeight = () => {
    nav.style.height = `${getViewportHeight() - header.offsetHeight}px`;
  };

  this.show = () => {
    if (this.state.isOpen) return;

    this.state.isOpen = true;

    disableBodyScroll(navScrollSpace);

    header.classList.add('nav-is-open');
    setNavScrollSpaceHeight();

    window.addEventListener('resize', setNavScrollSpaceHeight);

    this.sel.dispatchEvent(showEvent);
  };

  this.hide = () => {
    if (!this.state.isOpen) return;

    this.state.isOpen = false;

    enableBodyScroll(navScrollSpace);
    clearAllBodyScrollLocks();

    header.classList.remove('nav-is-open');
    nav.style.height = '';

    window.removeEventListener('resize', setNavScrollSpaceHeight);
  };

  button.addEventListener(
    'click',
    () => {
      if (this.state.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    },
    false,
  );

  window.addEventListener('orientationchange', this.hide);
}

/**
 * Toggle SubNavigation
 */

function ToggleSubNav() {
  const header = document.querySelector('.header');
  const navScrollSpace = header.querySelector('.header__nav-inner');
  const navItems = header.querySelectorAll('.header__nav-item');
  const subnavMenuItem = header.querySelector('.header__nav-item--subnav');
  const navSimpleItems = Array.prototype.slice
    .call(navItems)
    .filter(item => item !== subnavMenuItem);
  const subnavButton = subnavMenuItem.querySelector('.header__nav-link');
  const subnavBody = subnavMenuItem.querySelector('.header__subnav');
  const subnavScrollSpace = subnavBody.querySelector('.subnav__inner');

  if (!subnavMenuItem || !subnavButton || !subnavBody) return;

  this.state = {
    isOpen: false,
    scrollEventsPrevented: false,
  };

  this.show = () => {
    if (this.state.isOpen) return;

    this.state.isOpen = true;

    subnavMenuItem.classList.add('is-open');

    if (!isMobile()) {
      if (!isIEcheck()) {
        disableScroll.on();
      }

      this.scrollEventsPrevented = true;
      clickOutside(subnavBody, this.hide);
    } else {
      disableBodyScroll(subnavScrollSpace);
      navScrollSpace.style.overflow = 'hidden';

      const subnavHeight = Math.floor(
        getViewportHeight() - subnavScrollSpace.getBoundingClientRect().top,
      );

      subnavBody.style.height = `${subnavHeight}px`;
    }

    navSimpleItems.forEach(item => {
      item.classList.add('header__nav-item--hidden');
    });
  };

  this.hide = () => {
    if (!this.state.isOpen) return;

    this.state.isOpen = false;

    enableBodyScroll(subnavScrollSpace);

    navSimpleItems.forEach(item => {
      item.classList.remove('header__nav-item--hidden');
    });
    subnavMenuItem.classList.remove('is-open');

    if (this.scrollEventsPrevented) {
      disableScroll.off();
    }

    navScrollSpace.style.overflow = '';
    subnavBody.style.height = '';
  };

  subnavButton.addEventListener(
    'click',
    e => {
      e.stopPropagation();
      if (this.state.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    },
    false,
  );

  window.addEventListener('orientationchange', this.hide);

  document.onkeydown = e => {
    let isEscape = false;
    if ('key' in e) {
      isEscape = e.key === 'Escape' || e.key === 'Esc';
    } else {
      isEscape = e.keyCode === 27;
    }
    if (isEscape) {
      this.hide();
    }
  };
}

window.addEventListener('DOMContentLoaded', () => {
  const toggleNav = new ToggleNav();
  const toggleSubNav = new ToggleSubNav();
  stickyHeader();

  toggleNav.sel.addEventListener('show', () => {
    toggleSubNav.hide();
  });
});
